import React from 'react'
import { Link } from 'react-router-dom'
import { Modal } from './elements'

export default function LoginPrompt({openAuthModal, closeAuthModal, ...props}) {
  return (
    <Modal open={openAuthModal} setOpen={closeAuthModal} {...props}>
    <div>
      <h1 className="text-inputBorder text-4xl">You need to sign in</h1>
      <p className="my-4">
        To proceed, please log into your account or sign up if you do not
        have an account with us. This is to protect you and ensure your
        transaction is safe.
      </p>
      <div className="flex items-center justify-center gap-4 mt-2">
        <Link to="/login"><button className="btn btn-outline px-8">Sign in</button></Link>
        <Link to="/signup"><button className="btn btn-outline px-8">Sign up</button></Link>
      </div>
    </div>
  </Modal>
  )
}
